module.exports = __webpack_public_path__ + "static/img/4.ab68848.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/4.png
// module id = +TIe
// module chunks = 1